export default {
  title: "تصنيفات الأسئلة الشائعة",
  subtitle: "إدارة تصنيفات الأسئلة الشائعة",

  addNew: "إضافة تصنيف جديد",
  createFaqCategory: "إنشاء تصنيف",
  editFaqCategory: "تعديل التصنيف",
  deleteFaqCategory: "حذف التصنيف",

  actions: {
    back: "رجوع",
    update: "تحديث",
    updating: "جاري التحديث..."
  },

  fields: {
    name: "الاسم",
    description: "الوصف",
    displayOrder: "ترتيب العرض",
    isActive: "نشط"
  },

  placeholders: {
    name: "أدخل الاسم بالعربية والإنجليزية",
    description: "أدخل الوصف بالعربية والإنجليزية"
  },

  messages: {
    createSuccess: "تم إنشاء التصنيف بنجاح",
    createError: "فشل في إنشاء التصنيف",
    updateSuccess: "تم تحديث التصنيف بنجاح",
    updateError: "فشل في تحديث التصنيف",
    deleteSuccess: "تم حذف التصنيف بنجاح",
    deleteError: "فشل في حذف التصنيف",
    deleteConfirm: "هل أنت متأكد من حذف هذا التصنيف؟",
    noFaqCategories: "لا توجد تصنيفات أسئلة شائعة",
    fetchError: "فشل في جلب تصنيفات الأسئلة الشائعة"
  },

  validation: {
    nameRequired: "الاسم مطلوب",
    fillAllFields: "يرجى تعبئة جميع الحقول المطلوبة"
  },

  table: {
    displayOrder: "الترتيب",
    name: "الاسم",
    description: "الوصف",
    status: "الحالة",
    actions: "الإجراءات"
  },

  status: {
    active: "نشط",
    inactive: "غير نشط"
  },

  breadcrumbs: {
    faqCategories: "تصنيفات الأسئلة الشائعة",
    create: "إنشاء تصنيف",
    edit: "تعديل التصنيف"
  }
};
